import './App.css';
import Proyectos from './Componentes/Proyectos';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/consultadeproyectos" element={<Proyectos />} />
        <Route path="*" element={<Proyectos />} />
      </Routes>
    </Router>
  );
}

export default App;
